import React from 'react';

import Button from '../../../../library/button/button';
import AddProductButton from '../../../../components/add-product-button/add-product-button';
import ProductListCardDetails from '../product-list-card-details/product-list-card-details';
import ProductListCardPromos from '../product-list-card-promos/product-list-card-promos';
import ProductListSetCardPosition from '../product-list-set-card-position/product-list-set-card-position';

import { useProductQuantity } from '../../../../shared/hooks/hooks';

import {
  getProductSet,
  getProductSetItem,
  isCanonicalProduct
} from '../../../../shared/utils/product/product';
import { isArrayWithLength } from '../../../../shared/utils/validators/validators';

import {
  ProductData,
  ProductTypeEnum
} from '../../../../shared/types/graphql-types';
import { ProductItem } from '../../../../shared/types/product';
import { SetSearchTypes } from '../../../../shared/constants/set-products';

import './product-list-set-card.scss';

interface ProductListSetCardProps {
  onAddProductClick: (productItem: ProductItem) => void;
  onCheckInventoryClick: () => void;
  onViewProductClick: () => void;
  product: ProductData;
  productSetSearchType?: SetSearchTypes;
}

function ProductListSetCard(props: ProductListSetCardProps) {
  const {
    onAddProductClick,
    onCheckInventoryClick,
    onViewProductClick,
    product,
    productSetSearchType
  } = props;
  const productSet = getProductSet(product);
  const productDetailUrl = product?.url || '';
  const isCanonical = isCanonicalProduct(product);

  const {
    productSetQuantity,
    quantity,
    setProductSetQuantity,
    setQuantity,
    totalQuantity
  } = useProductQuantity({
    initialSetQuantity: productSet?.map(() => 1),
    productType: ProductTypeEnum.Accessories
  });

  const productSetItem = getProductSetItem(
    productSet,
    productSetQuantity,
    totalQuantity
  );

  const isSet = productSetSearchType === SetSearchTypes.SET;

  if (window['isPreRendering']) {
    return <div data-testid="product-list-set-card--empty" />;
  }

  return (
    <div
      data-testid="product-list-set-card"
      id={product && product.code ? `product-code-${product.code}` : ''}
      styleName="container"
    >
      <ProductListCardDetails
        header={isSet ? 'Contains 2 Wiper Blades' : 'Contains 1 Wiper Blade'}
        hideProductSize
        onCheckInventoryClick={onCheckInventoryClick}
        onViewProductClick={onViewProductClick}
        product={product}
        productDetailUrl={`${productDetailUrl}${isSet ? '/set' : ''}`}
        productSet={isSet ? productSet : undefined}
        quantity={productSetQuantity[0]}
      />

      <div styleName="actions">
        {isSet ? (
          productSet.map((product, index) => (
            <ProductListSetCardPosition
              index={index}
              isCanonical={isCanonical}
              key={product?.code}
              onQuantityChange={(quantity, index) =>
                setProductSetQuantity(quantity, index)
              }
              product={product}
              quantity={productSetQuantity[index]}
              totalQuantity={totalQuantity}
            />
          ))
        ) : (
          <ProductListSetCardPosition
            isCanonical={isCanonical}
            key={product?.code}
            onQuantityChange={quantity => setQuantity(quantity)}
            product={product}
            quantity={quantity}
            totalQuantity={totalQuantity}
          />
        )}

        <ProductListCardPromos product={productSet?.[0]} />

        {isCanonical ? (
          <Button
            href={productDetailUrl}
            isPrimary
            onClick={onViewProductClick}
            styleName="button"
          >
            View Details
          </Button>
        ) : (
          <AddProductButton
            onClick={onAddProductClick}
            productItem={
              isSet && isArrayWithLength(productSet)
                ? productSetItem
                : {
                    product: product,
                    quantity: quantity,
                    totalQuantity: totalQuantity
                  }
            }
            styleName="button"
          />
        )}
      </div>
    </div>
  );
}

export default ProductListSetCard;
